import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/reports'

const auditForm = async(props) => {
  const { default: AuditReportConfigurationsForm } = await import('@/vue_widgets/audit_report_configurations/form/index.vue')
  createVueApp(AuditReportConfigurationsForm, { props, sidebar })
}

Styxie.Initializers.AuditReportConfigurations = {
  index: async(props) => {
    const { default: AuditReportConfigurationsIndex } = await import('@/vue_widgets/audit_report_configurations/index.vue')
    createVueApp(AuditReportConfigurationsIndex, { props, sidebar })
  },
  new: auditForm,
  edit: auditForm
}
